import {h, Component, Fragment} from 'preact';
import {createRef} from 'preact/compat';
import PropTypes from 'prop-types';
import CameraInput from "./CameraInput";

export default class Modal extends Component {
	static propTypes = {
		onClose: PropTypes.func.isRequired,
	};

	constructor(props){
		super(props);
		this.modalRef = createRef();

		this.modalInstance = null;
	}

	componentDidMount(){
		this.modalInstance = $.fancybox.open(this.modalRef.current, {
			touch: false,
			afterClose: this.props.onClose,
		});
	}

	onChange = (file, dataUrl) => {
		this.modalInstance.close();
		this.props.onChange(file, dataUrl);
	}

	render(props, state, context){
		return (
			<div style={{display: 'none'}}>
				<div ref={this.modalRef} className='modal-photo' id="camera-modal" style="display: inline-block;">
					<button className="modal-photo__close-btn" aria-label="Закрыть" data-fancybox-close>
						<img className="modal-photo__icon" src="/terminal/img/icons/icon-modal-close.svg"/>
					</button>
					<CameraInput onChange={this.onChange}/>
				</div>
			</div>
		)
	}
}
